define(function (require) {
    var $ = require("jquery");
    require("jquery-inputmask");

    var hasInitializedCustomInputMasks = false;

    function initCustomInputMasks() {
        if (hasInitializedCustomInputMasks === true) {
            return;
        }

        Inputmask.extendAliases({
            "MM/DD/YYYY": {
                mask: "1/2/y",
                placeholder: "MM/DD/YYYY",
                leapday: "02/29/",
                separator: "/",
                alias: "mm/dd/yyyy"
            }
        });
        Inputmask.extendAliases({
            "MM/DD/AAAA": {
                mask: "1/2/y",
                placeholder: "MM/DD/AAAA",
                leapday: "02/29/",
                separator: "/",
                alias: "mm/dd/yyyy"
            }
        });
        Inputmask.extendAliases({
            "mm/dd/aaaa": {
                mask: "1/2/y",
                placeholder: "mm/dd/aaaa",
                leapday: "02/29/",
                separator: "/",
                alias: "mm/dd/yyyy"
            }
        });

        hasInitializedCustomInputMasks = true;
    }

    function bindCustomDateInputMask(element) {
        if (!element) {
            return;
        }

        initCustomInputMasks();

        var placeholderValue = element.attr("placeholder");
        var inputMaskAlias = "MM/DD/YYYY";

        switch (placeholderValue) {
            case "MM/DD/AAAA":
            case "MM/DD/YYYY":
            case "mm/dd/aaaa":
            case "mm/dd/yyyy":
                inputMaskAlias = placeholderValue;
                break;
            default:
                inputMaskAlias = "mm/dd/yyyy";
                break;
        }

        element.inputmask(inputMaskAlias);
    }

    return {
        initCustomInputMasks: function () {
            initCustomInputMasks();
        },
        bindCustomDateInputMask: function (element) {
            bindCustomDateInputMask(element);
        }
    };
});
